import React from "react";
import BackButton from "./BackButton";

const MobilePatternHeader = ({
  title,
  onBack,
  right,
  className = "",
  titleClassName = "",
}) => {
  return (
    <header
      className={[
        "sticky top-0 z-30 flex h-[64px] w-full shrink-0 items-center justify-between overflow-hidden bg-[#0155F8] px-3 text-white shadow-sm",
        className,
      ].join(" ")}
    >
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="absolute -right-12 -top-20 size-40 rounded-full border-[28px] border-white/10" />
        <div className="absolute -left-10 -top-8 h-20 w-20 rounded-full bg-white/10" />
        <div className="absolute left-[50%] top-5 size-5 -translate-x-1/2 rounded-full border-[5px] border-white/10" />
      </div>

      <BackButton
        ariaLabel="Quay lại"
        className="relative z-10 rounded-full"
        onClick={onBack}
        size="sm"
        variant="onDark"
      />

      <h1
        className={[
          "relative z-10 max-w-[70%] truncate text-center font-sf text-base font-medium leading-none text-white",
          titleClassName,
        ].join(" ")}
      >
        {title}
      </h1>

      <div className="relative z-10 flex size-9 items-center justify-center">
        {right}
      </div>
    </header>
  );
};

export default MobilePatternHeader;
